import React from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { useIncidentLogDataCategoriesField } from "./IncidentLogDataCategoriesField.hooks.ts";

export interface IncidentLogDataCategoriesFieldProps {
    label: string;
    dataCategoryIds: Array<string>;
    onChange: (dataCategoryIds: Array<string>) => void;
    isLoading: boolean;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogDataCategoriesField(props: IncidentLogDataCategoriesFieldProps) {
    const { translateString } = useTranslation();
    const { isLoading, dataCategoryOptions } = useIncidentLogDataCategoriesField(props.isPreview);

    return (
        <DotLegalMultiSelect
            options={dataCategoryOptions}
            chosenOptions={props.dataCategoryIds}
            onChange={props.onChange}
            label={props.label}
            placeholder={translateString("incidentDataCategorySelectorPlaceholder")}
            noOptionsLabel={translateString("noOptions")}
            isLoading={isLoading || props.isLoading}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogDataCategoriesField;
